import type { AdditionalAddendumContentAdvancedCare } from "@/core/types";
import { boolToRadio } from "@/lib/helpers/radio-adapters";
import { Radio2 } from "@/components/UI2/atoms/Radio";
import { RadioGroup2 } from "@/components/UI2/molecules/RadioGroup";

import { SCREENING_QUESTIONS } from "./AcaAddendum.constants";

type AcaAddendumDisplayProps = {
  additionalContent: Nullable<AdditionalAddendumContentAdvancedCare> | undefined;
};

export function AcaAddendumDisplay({ additionalContent }: AcaAddendumDisplayProps) {
  // Only render questions the provider actually answered — an ACA
  // addendum may touch just one of the four (client requirement).
  const answeredQuestions = additionalContent
    ? SCREENING_QUESTIONS.filter(
        ({ name }) => additionalContent[name] !== null && additionalContent[name] !== undefined,
      )
    : [];

  if (answeredQuestions.length === 0) {
    return null;
  }

  return (
    <div className="tw:grid tw:grid-cols-2 tw:gap-6">
      {answeredQuestions.map(({ name, testId, title }) => (
        <RadioGroup2
          hasStrongLabel
          key={name}
          label={title}
          mode="display"
          testId={`noteAddendumAcaa${testId}Display`}
          value={boolToRadio(additionalContent?.[name]) as string}
        >
          <Radio2 value="Yes">Yes</Radio2>
          <Radio2 value="No">No</Radio2>
        </RadioGroup2>
      ))}
    </div>
  );
}
